import type { AxiosError } from 'axios'
import { t } from 'i18next'
import { Link } from 'react-router'

import { Button } from '@/components/ui'

type FallbackErrorProps = {
  error: AxiosError<unknown>
  resetErrorBoundary: (...args: unknown[]) => unknown
}

export const ErrorPage = ({ error, resetErrorBoundary }: FallbackErrorProps) => {
  return (
    <div className="animate-in fade-in flex min-h-[80vh] flex-col items-center justify-center gap-8 p-4 duration-500">
      <div className="relative mb-4 h-24 w-24 animate-pulse">
        <div className="bg-primary/10 absolute inset-0 animate-pulse rounded-full" />
        <div className="bg-primary/20 absolute inset-2 animate-pulse rounded-full" />
        <div className="bg-primary/30 absolute inset-4 animate-pulse rounded-full" />
        <div className="bg-primary/5 absolute inset-3 animate-ping rounded-full" />
      </div>
      <div className="max-w-2xl space-y-4 text-center">
        <h1 className="text-3xl font-bold tracking-tighter">{t('common:error_boundary.titulo')}</h1>
        <p className="text-muted-foreground text-base">{t('common:error_boundary.descricao')}</p>
        {error?.code && <p className="text-muted-foreground mt-1 font-mono text-xs">Error ID: {error.code}</p>}
        {error?.message && (
          <p className="text-muted-foreground mt-1 font-mono text-xs font-semibold">
            {error.message}:
            {!!error?.response?.data && <span className="font-normal">{JSON.stringify(error?.response?.data)}</span>}
          </p>
        )}
      </div>

      <div className="flex w-full max-w-xs min-w-[200px] flex-col gap-4 sm:flex-row">
        <Button
          variant="default"
          className="w-full transition-all hover:scale-105"
          onClick={resetErrorBoundary}
          asChild
        >
          <Link to="/">{t('common:error_boundary.voltar')}</Link>
        </Button>
      </div>
    </div>
  )
}
